import './styled.scss';
import { useRef, useEffect, useState } from 'react';

import { contentSection, dataSlide, titleSection, ILocation } from 'data/location';
import { GetMobileStyledCompImg } from 'common-modules/general/Modules/functions';
import { GetGeocode } from 'common-modules/general/Modules/functions';

import pinMain from 'assets/common/ico_pin03.png';
import pinSub from 'assets/common/ico_pin05.png';
import { Swiper, SwiperSlide } from 'swiper/react';

import developmentPlan01 from 'assets/Desktop/images/parcelOut/dev01.jpg';
import developmentPlan02 from 'assets/Desktop/images/parcelOut/dev02.jpg';
import developmentPlan03 from 'assets/Desktop/images/parcelOut/dev03.jpg';

const Event = () => {
  // pop-up initial
  const popUp = useRef<any>(null);
  const popUpImg = useRef<any>(null);

  const openPopUp = (popUpName, img?: any) => {
    popUpName.current.style.visibility = 'visible';
    popUpName.current.style.opacity = 1;
    const body = document.body;

    body.style.overflow = 'hidden';

    if (img) {
      popUpImg.current.setAttribute('src', img);
    }
  };
  const closePopUp = popUpName => {
    popUpName.current.style.visibility = 'hidden';
    popUpName.current.style.opacity = 0;
    const body = document.body;

    body.style.overflow = 'unset';
  };

  const [selectedAddress, setSelectedAddress] = useState<ILocation>({
    img: '',
    title: '현장',
    address: '경상북도 구미시 상모동 373-2번지'
  });

  const handleClickMap = (sp: ILocation) => {
    setSelectedAddress(sp);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // #1. 네이버맵을 위한 좌표 변환
        const address_1: string = selectedAddress.address;
        const item: naver.maps.Service.AddressItemV2 = await GetGeocode(address_1);
        const fixItem: naver.maps.Service.AddressItemV2 = await GetGeocode('경상북도 구미시 상모동 373-2번지');
        // 네이버맵 가동 (현장위치)
        const location_1_map: naver.maps.Map = new naver.maps.Map('location_1', {
          center: new naver.maps.LatLng(Number(item.y), Number(item.x)),
          zoom: 15, // 지도의 초기 줌 레벨
          minZoom: 13, // 지도의 최소 줌 레벨
          maxZoom: 18, // 지도의 최대 줌 레벨
          zoomControl: true, // 줌 컨트롤의 표시 여부
          mapTypeControl: true
        });

        // 네이버맵 보조 마커 표시 (현장위치)
        const promises: Promise<void>[] = dataSlide.map((value: any) => {
          return new Promise<void>(async resolve => {
            try {
              const _i: naver.maps.Service.AddressItemV2 = await GetGeocode(value.address);

              if (value.address !== selectedAddress.address) {
                new naver.maps.Marker({
                  title: value.title,
                  position: new naver.maps.LatLng(Number(_i.y), Number(_i.x)),
                  map: location_1_map,
                  icon: pinSub
                });
              }
              resolve();
            } catch {
              resolve();
            }
          });
        });

        await Promise.all(promises);

        if (selectedAddress.title !== '현장') {
          // 네이버맵 마커 표시 (현장위치)
          new naver.maps.Marker({
            position: new naver.maps.LatLng(Number(item.y), Number(item.x)),
            map: location_1_map,
            icon: {
              content: `     <div class='pin'>
                <span class='pin-container'>
                  <span class='pin-img'><img src=${pinMain} alt=${selectedAddress.title} /></span>
                  <span class='pin-title' >${selectedAddress.title}</span>
                </span>
              </div>
              `,
              size: new naver.maps.Size(38, 58)
            }
          });
        }

        new naver.maps.Marker({
          position: new naver.maps.LatLng(Number(fixItem.y), Number(fixItem.x)),
          map: location_1_map,
          icon: {
            content: `     <div class='pin'>
              <span class='pin-container'>
                <span class='pin-point' style="z-index: 1;"></span>
                <span class='pin-title' style="z-index: 1;">현장</span>
              </span>
            </div>
            `,
            size: new naver.maps.Size(38, 58),
            anchor: new naver.maps.Point(11, 11)

          }
        });
      } catch (e) {}
    };

    fetchData();
  }, [selectedAddress]);

  // 220830 add
  interface contentList {
    name: string;
    isActive: boolean;
  }

  const contentList = [
    { name: '특징', isActive: true},
    { name: '주변시설', isActive: true},
    { name: '개발 계획', isActive: false}
  ];

  return (
    <div className="contents-location-mobile">

      {/* 특징  */}
      {contentList[0].isActive ? (
      <div id="infoMap" className="infoMap">
        <div className="infoMap-icon">
          <div className="icon"></div>
        </div>
        <div className="infoMap-title">{titleSection.tit}</div>
        {/* <div className="infoMap-detail">{titleSection.desc}</div> */}
        <div className="infoMap-img">
          <img
            onClick={() => {
              openPopUp(popUp, titleSection.PositionImg);
            }}
            src={titleSection.PositionImg}
            alt=""
          />
        </div>
        {/* <div className="slideLocation-notice">
            <p>{titleSection.infoMap}</p>
          </div> */}
          <div className="noti-text">
            <p className="desc dash indent">{titleSection.infoMap}</p>
            <p className="desc dash indent">{titleSection.infoMap2}</p>
            <p className="desc dash indent">{titleSection.infoMap3}</p>
          </div>

        {/* 홍보문구 */}
        <div className="infoMap-content">
          {contentSection.map((value, idx) => {
            return (
              <div className="infoMap-content-items" key={idx}>
                <div className="title">{value.tit}</div>
                <ul className="list-items">
                  {value.desc.map((val, innerIdx) => (
                    <li key={innerIdx}>{val}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* <div className="infoMap-img">
          <img
            onClick={() => {
              openPopUp(popUp, titleSection.wideBirdsView);
            }}
            src={titleSection.wideBirdsView}
            alt=""
          />
        </div> */}
      </div>
      ) : null}

      {/* 주변시설 */}
      {contentList[1].isActive ? (
      <div id="sliceLocation" className="slideLocation">
        <div className="slideLocation-title">주변시설</div>
        <div className="slideLocation-subTitle">입지</div>
        <div className="slideLocation-detail">교육, 교통, 생활, 자연까지! 완벽한 입지를 누리다</div>
        <div className="slideLocation-img">
          <div id="location_1" style={{ width: '100%', height: '100%' }}></div>
        </div>
        <Swiper className="layout-slide" preventClicks={false} navigation={false} slidesPerView={1.6} spaceBetween={20}>
          <div className="layout-slide-wrapper">
            {dataSlide.map((item, index) => {
              return (
                <SwiperSlide key={index} className="layout-slide-item">
                  <div className="main-items-content layout-slide-item-title">{item.title}</div>

                  <img onClick={() => handleClickMap(item)} className="layout-slide-item-img" src={item.img} alt="" />
                </SwiperSlide>
              );
            })}
          </div>
        </Swiper>

        <div className="slideLocation-notice">* 본 사진은 2022년 09월에 촬영된 사진입니다.</div>
      </div>
      ) : null}

      {/* 개발 계획 */}
      {contentList[2].isActive ? (
      <div id="infoHouse" className="infoHouse">
        <div className="infoHouse-title">개발계획</div>
        <div>
          <div className="infoHouse-subTitle line-height01">대전도시철도 2호선 트램<br/> “기본계획 변경” 추진</div>
          <div className="infoHouse-content">
            <div className="infoHouse-content-left">
              <div className="content-detail">
                <div className="content-detail-items">
                  <p className='content-detail-items__tit'>대전역 경유, 정거장 추가 등 기본설계 반영 따른 총사업비, 사업기간 조정</p>
                  <div className='content-detail-items__list'>
                    <h3>[기본계획 변경사유]</h3>
                    <ul>
                      <li>① 기본설계 결과 반영한 총사업비 조정</li>
                      <li>② 대전역 경유 등 노선 확정(36.6㎞ → 38.1㎞ / 증 1.5㎞)</li>
                      <li>③ 접근편의성, 이용수요 고려한 정거장 확충<br/>(35개소 → 45개소) / 증 10개소</li>
                      <li>④ 사업기간 현실화(개통 2027년 → 2028년 / 증 1년)</li>
                    </ul>
                    <span>※ 근거 : 도시철도법 제6조</span>
                  </div>

                  <div className='content-detail-items__list'>
                    <h3>[총사업지 조정현황]</h3>
                    <p className='mt-5 mb-5 line-height02'>
                      * 총사업지 조정 사유<br/>
                      당초 예비타당성조사 운용지침에 따라 개략적인 사업비를 계상하였으나, 정확한 현장조사 및 기술여건, 운행안전성 확보, 이용 편의성 등을 위해 총사업비 증가
                    </p>
                    <span>※ 근거 : 총사업비관리지침 제49조의2</span>
                  </div>

                  <div className='content-detail-items__list'>
                    <h3>[향후 일정]</h3>
                    <ul className='desc'>
                      <li>기본계획 변경 및 총사업비 조정(2023. 上)</li>
                      <li>실시설계 및 사업계획 승인(2023. 下)</li>
                      <li>공사 추진 및 개통(2024. ~ 2028.)</li>
                    </ul>
                  </div>
                </div>

                <div className="content-detail-notice line-height01">
                  <span className="tit">
                    ※ 자료출처 : KDI공공투자관리센터
                  </span>
                  <span className="tit mt-5">
                    ※ 자료출처 : 한국거래소시스템즈(KMS), www.ebunyang.co.kr 국토교통부
                  </span>
                </div>
              </div>
            </div>
            <div className="infoHouse-content-right">
              <img
                onClick={() => {
                  openPopUp(popUp, developmentPlan01);
                }}
                src={developmentPlan01}
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="mt-35">
          <div className="infoHouse-subTitle">도안대로 도로개설공사 "본격화"</div>
          <div className="infoHouse-content">
            <div className="infoHouse-content-left">
            <div className="content-detail">
                    <div className="content-detail-items">
                      <p className='content-detail-items__tit'>서남부지역 교통 혼잡 개선 및 도안 2·3단계 도시개발 촉진</p>
                    </div>
                    <div className="content-detail-items">
                      <span className="title">위 치</span>
                      <span className="detail">서구 관저동(원앙마을) ~ 유성구 용계동(목원대입구)</span>
                    </div>
                    <div className="content-detail-items">
                      <span className="title">사업내용</span>
                      <span className="detail">도로개설 L=1.9km, B=50m / 생태통로 1개소</span>
                    </div>
                    <div className="content-detail-items">
                      <span className="title">사 업 비</span>
                      <span className="detail">1,177억(보상 798, 공사 363, 기타 16) / 시비 </span>
                    </div>
                    <div className="content-detail-items">
                      <span className="title">시 공 자</span>
                      <span className="detail">산정현건설(주) 외 2개사(명덕건설, 동아건설산업) / 도급액 140억 </span>
                    </div>
                    <div className="content-detail-items">
                      <span className="title">감 리 자</span>
                      <span className="detail">㈜경원엔지니어링 외 1개사(동양엔지니어링)</span>
                    </div>
                    <div className="content-detail-items">
                      <span className="title">사업기간</span>
                      <span className="detail">2013년 ~ 2023년</span>
                    </div>
                    <div className="content-detail-items">
                      <div className='content-detail-items__list'>
                        <h3>추진사항</h3>
                        <ul className='desc'>
                          <li>`13. 06. : 기본설계 착수(준공 `15.11.)</li>
                          <li>`15. 09. : 실시설계 착수(준공 `17.12.)</li>
                          <li>`16. 03. ~ 06. : 생태통로 건설기술심의 및 경관심의</li>
                          <li>`17. 01. 24. : 도시계획시설사업 실시계획인가 고시</li>
                          <li>`17. 06. 30. : 1차구간(대정동) 보상협의(131필지, 63,439㎡)</li>
                          <li>`17. 07. 05. : 공사착공 및 감리용역착수</li>
                          <li>`18. 02. 12. : 2차구간(용계동) 보상협의(202필지, 60,981㎡)</li>
                          <li>`18. 11. 現 : 대정동구간 수목제거, 건물철거 추진 중</li>
                        </ul>
                      </div>

                      <div className='content-detail-items__list'>
                        <h3>추진계획</h3>
                        <ul className='desc'>
                          <li>`19. 6. : 1차 구간 공사 완료 예정</li>
                          <li>`20. 12. : 전체구간 공사 완료 예정</li>
                        </ul>
                      </div>
                    </div>
                    <div className="content-detail-notice">
                      <span>
                        ※ `23. 하반기 : 개통기간 연기<br/>
                        ※ 6차로에서 10차로로 확장개통
                      </span>
                    </div>
                  </div>
            </div>
            <div className="infoHouse-content-right">
              <img
                onClick={() => {
                  openPopUp(popUp, developmentPlan02);
                }}
                src={developmentPlan02}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="mt-35">
          <div className="infoHouse-subTitle">충청권 광역철도</div>
          <div className="infoHouse-content">
            <div className="infoHouse-content-left">
              <div className="content-detail">
                <div className="content-detail-items">
                  <p className='content-detail-items__tit'>
                    도심 국철을 광역철도로 활용, 남북축을 잇는 도시철도 3호선 역할<br/>
                    도시철도 1·2호선과 연계한 철도중심의 대중교통 기반 구축
                  </p>
                </div>
                <div className="content-detail-items">
                  <span className="title">사업구간</span>
                  <span className="detail">계룡 ~ 신탄진 / 35.4㎞ (대전시 32.67㎞, 충남 2.73㎞) </span>
                </div>
                <div className="content-detail-items">
                  <span className="title">사업기간</span>
                  <span className="detail">2016 ~ 2024년 / 2024년 개통</span>
                </div>
                <div className="content-detail-items">
                  <span className="title">총사업비</span>
                  <span className="detail">2,694억 원(국비 1,392억원, 지방비 1,302억원)</span>
                </div>
                <div className="content-detail-items">
                  <span className="title">사업내용</span>
                  <span className="detail">정거장 개량 및 신설(12개소), 기존선로 활용</span>
                </div>
                <div className="content-detail-items">
                  <div className='content-detail-items__list'>
                    <h3>추진사항</h3>
                    <ul className='desc'>
                      <li>제2차 국가철도망구축계획 반영 고시(’11. 4.)</li>
                      <li>사전타당성조사 실시(’13. 5. ~ 11.) / 국가철도공단</li>
                      <li>기획재정부･KDI 예비타당성조사(’14. 5. ~ ’15. 11.)</li>
                      <li>기본계획 및 전략환경영향평가 용역 추진(’16. 3. ~ ’18. 12.)</li>
                      <li>총사업비 조정(’18. 7.) / 2,107억 원 → 2,307억 원(증 200억원)</li>
                      <li>기본계획 고시(’18. 12.)</li>
                      <li>기본 및 실시설계 착수(’19. 12.) / 국가철도공단</li>
                      <li>선로용량 검토관련 회의(’20. 5.) / 국토부, 대전시, 철도공단 → 기존노선 활용</li>
                      <li>노반 기본설계(안) 주민 공람 시행(’20. 12. 11. ~ 30.)</li>
                      <li>운영협약 체결(’21. 4.) / 국토부, 대전시, 충남도, 국가철도공단, 한국철도공사</li>
                      <li>총사업비 조정(’21. 8.) / 2,307억 원 → 2,694억 원(증 387억원)</li>
                    </ul>
                  </div>

                  <div className='content-detail-items__list'>
                    <h3>향후 계획</h3>
                    <ul className='desc'>
                      <li>노반 분야 기본 및 실시설계 용역 준공(’21. 11.)</li>
                      <li>공사(’22. ~ ’24. 상반기), 시운전 및 개통(’24. 하반기)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="infoHouse-content-right">
              <img
                onClick={() => {
                  openPopUp(popUp, developmentPlan03);
                }}
                src={developmentPlan03}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="infoHouse-notice">
          <p>* 자료출처 : 대전광역시 보도자료(2022.06.17. 트램도시광역본부 트램건설과)</p>
          <p>* 상기개발계획은 사업주체, 국가기관, 지자체 및 기타기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.</p>
        </div>
      </div>
      ) : null}

      <div ref={popUp} className="pop-up">
        <div>
          <div className="pop-up-header">
            <img
              onClick={() => {
                closePopUp(popUp);
              }}
              className="btn-close"
              src={GetMobileStyledCompImg('common/ico_close02.png')}
              alt="icoClose02"
            />
          </div>
          <div className="pop-up-img">
            <img ref={popUpImg} src="" alt="DL건설" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Event;
